<template>
	<div>
		<!-- 收藏列表 -->
		<el-dialog width="1030px" :visible.sync="show" @open="getGameAllList()" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="fav_home_dialog fav_search_dialog flex_fc_ac_js" style="height: 750px;">
				<div style="width: 100%;">
					<div class="fav_home_dialog_close">
						<img @click="close()" class="fav_home_dialog_close_icon" src="../../../assets/icons/close_icon2.png"
							alt="" />
					</div>
					<div class="fav_search_dialog_title">
						{{title}}
					</div>
				</div>
				<div class="fav_home_game_list">
					<div v-if="gameList.length>0" class="fav_search_dialog_results_list">
						<div class="fav_search_dialog_results_item" v-for="(item,index) in gameList" :key="item.gameId"
							@click="clickGameDetali(item)" :class="(index+1)%8==0?'mar_r0':''">
							<img class="fav_search_dialog_results_item_img" :src="item.gameImage" alt="" />
						</div>
					</div>
					<div v-else class="fav_search_dialog_results_list flex_as_c">
						<img style="width: 200.22px;height: 222px;margin-top: 150px;"
							src="../../../assets/icons/list_no.png" alt="" />
					</div>
				</div>

				<div v-if="gameList.length>0" class="flex_as_c">
					<el-pagination background layout="prev, pager, next" :page-size="gamePar.pageSize"
						:total="gameTotal" @current-change="changePageNum">
					</el-pagination>
				</div>
			</div>
		</el-dialog>

		<!-- 游戏详情 -->
		<gameDetails :show="gameDetailsShow" :item="curGame" @close="gameDetailsShow=false">
		</gameDetails>

	</div>
</template>

<script>
	import gameDetails from './gameDetails.vue'
	export default {
		name: 'favoritesPage',
		components: {
			gameDetails,
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: 'Favorites'
			},
			type: {
				type: Number,
				default: 0
			},
			url: {
				type: String,
				default: 'getGameList'
			},
			gameList: {
				type: Array,
				default: () => []
			}

		},
		data() {
			return {
				gameDetailsShow: false,
				gamePar: {
					pageSize: 32,
					pageNum: 1,
					newStatus: '0',
					hotStatus: '0',
				},
				// gameList: [],
				gameTotal: 0,
				curGame:{},
			}
		},
		methods: {
			close() {
				this.$emit('close')
			},
			// 获取游戏列表
			getGameAllList() {
				this.gameTotal = this.gameList.length
				// if (this.type == 1) {
				// 	this.gamePar.hotStatus = 1
				// } else if (this.type == 2) {
				// 	this.gamePar.newStatus = 1
				// }
				// this.$api[this.url](this.gamePar).then(res => {
				// 	if (res.rows.length > 0) {
				// 		this.gameTotal = res.total
				// 		this.gameList = res.rows
				// 	}
				// })
			},
			changePageNum(e) {
				this.gamePar.pageNum = e
				this.getGameAllList()
			},
			clickGameDetali(item) {
				this.curGame = item
				this.gameDetailsShow = true
			},


		},
	}
</script>

<style scoped lang="scss">
	/*对话框*/
	
	.fav_home_dialog{
		position: absolute;
		left: 0;
		top: 0;
		width: 494px;
		min-width: 494px;
		min-height: 454px;
		background: #1F242F;
		border-radius: 18px;
		max-height: 820px;
		overflow-y:  auto;
		-ms-overflow-style: none;
		scrollbar-width: none;
		box-sizing: border-box;
	}
	
	.fav_search_dialog{
		width: 1030px;
		min-width: 1030px;
		height: 750px;
		box-sizing: border-box;
		padding: 40px 26px 39px;
	}
	
	.fav_home_dialog_close{
		position: absolute;
		top: 30px;
		right: 30px;
	}
	
	.fav_home_dialog_close_icon{
		width: 43.38px;
		height: 28.92px;
		cursor: pointer;
	}
	
	.fav_search_dialog_title{
		font-weight: 600;
		font-size: 28px;
		color: #FFFFFF;
		text-align: center;
	}
	
	.fav_search_dialog_search{
		background: #161A22;
		border-radius: 8px;
		border: 1px solid #223B50;
		box-sizing: border-box;
		padding: 0 11px;
		display: flex;
		align-items: center;
		cursor: pointer;
		margin-top: 35px;
	}
	
	.fav_search_dialog_fav_search_icon{
		width: 24px;
		height: 24px;
	}
	
	.fav_search_dialog_fav_search_input{
		flex: 1;
		background: #161A22;
		color: #737982;
		font-size: 14px;
		margin-left: 5px;
	}
	
	.fav_search_dialog_remark{
		margin-top: 28px;
		font-weight: 500;
		font-size: 18px;
		color: #91A1BC;
		text-align: center;
	}
	
	.fav_search_dialog_results_list{
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		margin-top: 25px;
	}
	
	.fav_search_dialog_results_item{
		width: calc(100% / 8.68);
		margin-right: 10px;
		margin-bottom: 10px;
		cursor: pointer;
	}
	
	
	.fav_search_dialog_results_item_img{
		width: 100%;
		height: 100%;
		border-radius: 7px;
		overflow: hidden;
	}
	
	.fav_home_game_list{
		width: 100%;
		flex: 1;
		margin-top: 25px;
	}
	

	
	
	
</style>